/**
 * Stable page IDs for each level/exam/hub. Drives slug construction and
 * route paths in `buildLevelsContent`.
 *
 * Re-exported from `@/content/levelsContent` for backward compatibility.
 */

export const levelPageIds: Record<string, string> = {
  // Primary hub pages
  primary1: 'primary-1',
  primary2: 'primary-2',
  primary3: 'primary-3',
  primary4: 'primary-4',
  primary5: 'primary-5',
  primary6: 'primary-6',
  // Legacy PSLE page (redirects to primary-6)
  psle: 'psle',
  // Secondary hub pages
  sec1: 'sec-1',
  sec2: 'sec-2',
  sec3: 'sec-3',
  sec4: 'sec-4',
  // Secondary spoke pages (stream-specific)
  sec1G1: 'sec-1-g1',
  sec1G2: 'sec-1-g2',
  sec1G3: 'sec-1-g3',
  sec1IP: 'sec-1-ip',
  sec2G1: 'sec-2-g1',
  sec2G2: 'sec-2-g2',
  sec2G3: 'sec-2-g3',
  sec2IP: 'sec-2-ip',
  sec3G1: 'sec-3-g1',
  sec3G2: 'sec-3-g2',
  sec3G3: 'sec-3-g3',
  sec3IP: 'sec-3-ip',
  sec4G1: 'sec-4-g1',
  sec4G2: 'sec-4-g2',
  sec4G3: 'sec-4-g3',
  sec4IP: 'sec-4-ip',
  sec1IB: 'sec-1-ib',
  sec2IB: 'sec-2-ib',
  sec3IB: 'sec-3-ib',
  sec4IB: 'sec-4-ib',
  // Exam prep pages
  oLevel: 'o-level',
  nLevel: 'n-level',
  eMath: 'e-math',
  aMath: 'a-math',
  ip: 'ip',
  ib: 'ib',
  // Top-level school hub pages
  primarySchoolHub: 'primary-school',
  secondarySchoolHub: 'secondary-school',
};
